import { render, staticRenderFns } from "./CookieNoticeLink.vue?vue&type=template&id=2783fa86&"
import script from "./CookieNoticeLink.vue?vue&type=script&lang=js&"
export * from "./CookieNoticeLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports